import { CheckCircleIcon } from "@phosphor-icons/react/CheckCircle";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import type { ReactNode } from "react";

interface UserSelectItemProps {
  selected: boolean;
  onSelect: () => void;
  children: ReactNode;
}

/**
 * One selectable entry in the DashboardUserSelect menu — a Button, so that
 * inside a ui-core Menu it renders as a proper menu item.
 *
 * The check sits at the right edge rather than leading the row. Nothing these
 * rows name has an icon — they are people and branches — so the menu turns the
 * icon column off, which is what puts the labels flush with their own group
 * headers. With no column to sit in, a leading check would indent the selected
 * row and nothing else.
 */
export function DashboardUserSelectItem(props: UserSelectItemProps) {
  return (
    <Button onClick={props.onSelect}>
      {props.children}
      {props.selected && (
        <span className="ml-auto flex">
          <Icon
            icon={CheckCircleIcon}
            size="sm"
            weight="fill"
            color="text-brand-text group-data-[highlighted]:text-white"
          />
        </span>
      )}
    </Button>
  );
}
